import { Component, inject } from '@angular/core';
import { LogyardService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LogyardCreateDto,
  LogyardDto,
  LogyardExcelDownloadDto,
  LogyardUpdateDto,
} from '../proxy/planning/dtos/logyard';
import { LOGYARD_CONFIG, LOGYARD_FIELDS } from './logyard.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-logyard',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, LogyardService, ConfirmationService],
  templateUrl: './logyard.html',
  styleUrl: './logyard.scss',
})
export class Logyard extends BaseHierarchicalCrudComponent<
  LogyardDto,
  LogyardCreateDto,
  LogyardUpdateDto,
  LogyardExcelDownloadDto
> {
  service = inject(LogyardService);
  config = LOGYARD_CONFIG;
  fields = LOGYARD_FIELDS;

  protected prepareUpdateDto(data: any, selected: LogyardDto): LogyardUpdateDto {
    return {
      name: data.name,
      capacity: data.capacity,
      isEligibleForElectronicInvoice: data.isEligibleForElectronicInvoice,
      isDestinationWoodLog: data.isDestinationWoodLog,
      isTransferLogyard: data.isTransferLogyard,
      demandSaleContract: data.demandSaleContract,
      remsoftName: data.remsoftName,
      measurementTypeId: data.measurementTypeId,
      isActive: data.isActive,
      logyardTypeId: data.logyardTypeId,
      zoneId: data.zoneId,
      locationId: data.locationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Logyard';
  }
}
